// Unpublished Work © 2021-2022 Deere & Company

import {SET_CUSTOMER_IDS} from '../action-list';
import {CustomerIds} from '../state/struct/customer-ids';

const setCustomerIds = (state, action) => CustomerIds.update(state, {
    $merge: action.customerIds
});

export function customerIdsReducer(state = new CustomerIds({}), action = {}) {
    const actionHandlers = {
        [SET_CUSTOMER_IDS]: setCustomerIds
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
